import React from 'react';
import { observer } from 'mobx-react';
import BlankPageLayout from '../../../Layouts/BlankPageLayout';
import CharityDataModule from './CharityDataModule/CharityDataModule';

const CharityData = observer((): JSX.Element => {
  return (
    <BlankPageLayout>
      <div>
        <CharityDataModule />
      </div>
    </BlankPageLayout>
  );
});
export default CharityData;
